interface MailToProps {
    email: string;
}

const MailTo: FC<MailToProps> = ({ email }) => (email ? <a href={`mailto:${email}`}>{email}</a> : null);

export default MailTo;
